import { ChangeEvent, Component, createRef } from 'react';

import { GenericMouseEvent } from '../../../types/types';
import styles from './checkbox.component.module.scss';


interface CheckboxProps {
    initialValue: boolean;
    ariaLabel: string,
    emitInitialValueOnInit: boolean;
    onChange?: (value: boolean) => void;
}

interface CheckboxState {
    value: boolean;
    prevInitialValue: boolean;
}

export default class Checkbox extends Component<CheckboxProps, CheckboxState> {
    container = createRef<HTMLDivElement>();
    handler: ((e: GenericMouseEvent) => void) | null = null;
    eventOffset = 0;

    valueFormatter = (val: number) => val;

    readonly state: Readonly<CheckboxState> = this.initializeAndGetState();

    constructor(props: CheckboxProps) {
        super(props);
    }

    initializeAndGetState() {
        return {
            value: this.props.initialValue,
            prevInitialValue: this.props.initialValue
        }
    }

    static getDerivedStateFromProps(props: CheckboxProps, state: CheckboxState) {
        if (props.initialValue !== state.prevInitialValue) {
            return {
                value: props.initialValue,
                prevInitialValue: props.initialValue
            };
        }
        return null;
    }

    componentDidMount() {
        if (this.props.onChange) {
            this.props.onChange(this.state.value);
        }
    }

    valueChanged(e: ChangeEvent<HTMLInputElement>): void {
        const value = !!(e.target as any).checked;
        this.setState({
            value: value,
        });

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }


    render() {
        return (
            <div ref={this.container} className={styles.container}>
                <div className={`form-check form-switch ${styles['input-container']}`}>
                    <input className="form-check-input"
                        type="checkbox"
                        checked={this.state.value}
                        onChange={e => this.valueChanged(e)}
                        aria-label={this.props.ariaLabel}
                    />
                </div>
            </div>
        );
    }
}